import { StakingLocators } from '@app/e2e/screens/Staking/StakingLocators';
import {
	AppIcon,
	datePickerMaxDate,
	datePickerMinDate,
	datePickerService,
	dateTimePlaceholder,
	useAppTheme,
} from '@itrustcapital/ui';
import { Datepicker } from '@ui-kitten/components';
import { startOfDay } from 'date-fns';
import React from 'react';
import { Controller } from 'react-hook-form';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { useStakingScreenContext } from './StakingScreenProvider';

export function StakingFilterForm() {
	const styles = useCustomStyles();
	const context = useStakingScreenContext();
	const { reset, clearErrors, setValue } = context.stakingForm;

	const onRefreshDate = () => {
		reset();
		clearErrors();

		const todaysDate = startOfDay(new Date());
		setValue('createdAt', todaysDate);

		context.getDailyStakingEnrollments({
			variables: {
				input: {
					date: todaysDate.toISOString(),
				},
			},
		});
	};

	return (
		<>
			<View style={styles.main.filterRow}>
				<Controller
					control={context.stakingForm.control}
					name="createdAt"
					render={(control) => (
						<Datepicker
							date={control.field.value}
							dateService={datePickerService}
							label="Choose a date"
							max={datePickerMaxDate}
							min={datePickerMinDate}
							placeholder={dateTimePlaceholder}
							status={control.fieldState.error && 'danger'}
							style={styles.main.control}
							testID={StakingLocators.stakingCreatedAtField}
							onBlur={control.field.onBlur}
							onSelect={(date) => {
								control.field.onChange(date);
								context.getDailyStakingEnrollments({
									variables: {
										input: {
											date: new Date(date.setHours(0, 0, 0, 0)).toISOString(),
										},
									},
								});
							}}
						/>
					)}
				/>

				<TouchableOpacity
					testID={StakingLocators.stakingCreatedAtRefreshIcon}
					style={styles.main.refresh}
					onPress={() => onRefreshDate()}
				>
					<AppIcon
						lib="fe"
						name="refresh-ccw"
						size={20}
						style={styles.main.refreshIcon}
					/>
				</TouchableOpacity>
			</View>
		</>
	);
}

function useCustomStyles() {
	const theme = useAppTheme();

	return {
		main: StyleSheet.create({
			container: {
				flex: 1,
				justifyContent: 'center',
				alignItems: 'center',
				textTransform: 'capitalize',
			},
			control: {
				width: 300,
				marginRight: 8,
				paddingVertical: 8,
			},
			filterRow: {
				flexDirection: 'row',
				alignItems: 'center',
				width: '100%',
			},
			refresh: { justifyContent: 'center', alignItems: 'center' },
			refreshIcon: {
				color: theme['color-success-500'],
				fontWeight: '700',
				marginTop: 16,
			},
		}),
	};
}
